import { LoanType, LoanStatusType, LoanActionType } from '../LoanConstants';

export const getLoanActions = (
    loan: {
        id: number;
        propertyId: number;
        drawBudgetId: number;
        isPortfolio: boolean;
        subNoteCount: number;
        loanTypeId: LoanType;
        statusId: LoanStatusType;
        canReleaseHoldback: boolean;
        canDscr: boolean;
        canConvertToRental: boolean;
        isRental: boolean;
        canRollback: boolean;
        canRepay: boolean;
        bfiNumber: string;
    },
    isPropertyLevel = false
) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    if (loan.statusId === LoanStatusType.Lost || loan.statusId === LoanStatusType.Deleted) {
        if (!isPropertyLevel) {
            actions.push({
                id: LoanActionType.Summary,
                text: 'Summary',
                loanId: loan.id,
            });
            actions.push({
                id: LoanActionType.Restore,
                text: 'Restore',
                loanId: loan.id,
            });
            actions.push({
                id: LoanActionType.Modify,
                text: 'Loan Details',
                loanId: loan.id,
                loanTypeId: loan.loanTypeId,
                stylingMode: 'contained',
            });
        }
    } else {
        actions.push({
            id: LoanActionType.Modify,
            text: 'Loan Details',
            loanId: loan.id,
            loanTypeId: loan.loanTypeId,
            stylingMode: 'contained',
        });

        const convertTypes = [LoanType.FixFlip, LoanType.SubNoteFixFlip, LoanType.Construction, LoanType.SubNoteConstruction];
        if (!isPropertyLevel && loan.statusId === LoanStatusType.Approved && convertTypes.includes(loan.loanTypeId)) {
            actions.push({
                id: LoanActionType.ChangeLoanType,
                text: 'Change Loan Type',
                loanId: loan.id,
                disabled: false,
            });
        }

        if (!isPropertyLevel && loan.statusId === LoanStatusType.Approved) {
            actions.push({
                id: LoanActionType.LoanSetupSheet,
                text: 'Loan Setup Sheet',
                loanId: loan.id,
                bfiNumber: loan.bfiNumber,
                loanTypeId: loan.loanTypeId,
                disabled: false,
            });
        }

        if (loan.loanTypeId === LoanType.MasterNote) {
            actions.push({
                id: LoanActionType.AddSubNote,
                text: 'Add Sub Note',
                loanId: loan.id,
                disabled: loan.statusId !== LoanStatusType.Outstanding,
            });
            actions.push({
                id: LoanActionType.TerminateMasterNote,
                text: 'Terminate',
                loanId: loan.id,
                disabled: loan.statusId !== LoanStatusType.Outstanding,
            });
        }

        if (!isPropertyLevel && (loan.statusId === LoanStatusType.Outstanding || loan.statusId === LoanStatusType.Approved)) {
            actions.push({
                id: LoanActionType.Lost,
                text: 'Lost Loan',
                loanId: loan.id,
                disabled: loan.subNoteCount > 0,
            });
        }

        if (loan.loanTypeId !== LoanType.MasterNote) {
            if (loan.statusId === LoanStatusType.Outstanding) {
                if (loan.isRental) {
                    actions.push({
                        id: LoanActionType.ReleaseHoldback,
                        text: 'Release Holdback',
                        propertyId: loan.propertyId,
                        disabled: !loan.propertyId || !loan.canReleaseHoldback,
                    });

                    actions.push({
                        id: LoanActionType.RentalDscr,
                        text: 'DSCR',
                        propertyId: loan.propertyId,
                        disabled: !loan.propertyId || !loan.canDscr,
                    });
                }
                //else {
                //actions.push({ id: LoanActionType.Draw, text: 'Draw', loanId: loan.id, disabled: true });
                //}

                if (!isPropertyLevel && loan.loanTypeId === LoanType.BuildRent) {
                    actions.push({
                        id: LoanActionType.Convert,
                        text: 'Convert to Rental',
                        loanId: loan.id,
                        disabled: !loan.canConvertToRental,
                    });
                }

                if (loan.isPortfolio) {
                    actions.push({
                        id: LoanActionType.LoanRepayment,
                        text: 'Repayment',
                        loanId: loan.id,
                        disabled: !loan.id || !loan.canRepay,
                    });
                } else {
                    actions.push({
                        id: LoanActionType.PropertyRepayment,
                        text: 'Repayment',
                        propertyId: loan.propertyId,
                        disabled: !loan.propertyId || !loan.canRepay,
                    });
                }

                if (!isPropertyLevel) {
                    actions.push({
                        id: LoanActionType.RevertToApproved,
                        text: 'Revert to Apprvd',
                        loanId: loan.id,
                        disabled: !loan.canRollback,
                    });
                }
            }
        }

        if (
            loan.drawBudgetId &&
            (loan.statusId === LoanStatusType.Outstanding || loan.statusId === LoanStatusType.Repaid) &&
            loan.loanTypeId != LoanType.Rental
        ) {
            actions.push({
                id: LoanActionType.OpenDrawBudget,
                text: 'Draws',
                drawBudgetId: loan.drawBudgetId,
            });
        }
    }

    if (!isPropertyLevel && (loan.statusId === LoanStatusType.Outstanding || loan.statusId === LoanStatusType.Repaid)) {
        if (
            loan.loanTypeId != LoanType.MasterNote &&
            loan.loanTypeId !== LoanType.SubNoteConstruction &&
            loan.loanTypeId !== LoanType.SubNoteFixFlip
        ) {
            actions.push({
                id: LoanActionType.Extend,
                text: 'Extensions',
                loanId: loan.id,
                disabled: false,
            });
        }
        actions.push({
            id: LoanActionType.AuditHistory,
            text: 'Audit History',
            loanId: loan.id,
        });
    }

    if (!isPropertyLevel && (loan.statusId === LoanStatusType.Outstanding || loan.statusId === LoanStatusType.Approved)) {
        actions.push({
            id: LoanActionType.Delete,
            text: 'Delete Loan',
            loanId: loan.id,
            type: 'danger',
            icon: 'remove',
            disabled: loan.subNoteCount > 0,
        });
    }

    return actions;
};
